import { Action, createAction, props } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export const GO = '[Router] Go';
export const BACK = '[Router] Back';
export const FORWARD = '[Router] Forward';

export const Go = createAction(GO, props<{ path: any[]; queryParams?: object; extras?: NavigationExtras }>());
export const Back = createAction(BACK);
export const Forward = createAction(FORWARD);
